module.exports = __webpack_public_path__ + "media/images/arrow-down-42974fa7835233bc83bf6591f0e55da1.png";